import {
  APPROVED,
  CANCELLED,
  NEW
} from '@/modules/inhabitant_changes/common/statuses';

export default {
  data() {
    return {
      valid: true,
      request: {},
      statuses: []
    };
  },

  computed: {
    statusesList() {
      return this.statuses.map(status => {
        return {
          ...status,
          disabled: !this.enabledStatuses.includes(status.id)
        };
      });
    },

    enabledStatuses() {
      const status = this.request.status.id || NEW;

      switch (status) {
        case NEW:
          return [NEW, APPROVED, CANCELLED];
        case APPROVED:
          return [APPROVED];
        case CANCELLED:
          return [CANCELLED];
        default:
          return [];
      }
    },

    editable() {
      return this.request.status.id === NEW;
    },

    isEnabledUpdateButton() {
      if (!this.editable || this.request.status_id === NEW) {
        return false;
      }

      if (this.request.status_id === CANCELLED) {
        return true;
      }

      return this.valid;
    },

    hasValidate() {
      return this.request.status_id === APPROVED;
    }
  },

  methods: {
    validableUpdate() {
      if (this.hasValidate && !this.validate()) {
        return;
      }

      this.update();
    },

    validate() {
      return true;
    },

    update() {
      throw new Error('Not implemented "update" method');
    }
  }
};
